import { render, staticRenderFns } from "./IndividualPhonetic.vue?vue&type=template&id=4ba79864"
import script from "./IndividualPhonetic.vue?vue&type=script&lang=js"
export * from "./IndividualPhonetic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports